import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron right.svg` */
export const ChevronRightIcon = createTripletGlyphIcon('ChevronRightIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.32806 13.5248C5.02843 13.7687 4.58783 13.7236 4.34368 13.4242C4.09975 13.1245 4.14466 12.683 4.44427 12.4389L10.0937 7.83633L4.4638 3.57657C4.15583 3.34323 4.09489 2.90427 4.32806 2.5961C4.56131 2.28814 5.00034 2.2274 5.30853 2.46036L11.5566 7.18789C11.9652 7.49708 11.9762 8.1073 11.579 8.43106L5.32806 13.5248Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.90705 15.1471C5.60742 15.3908 5.16678 15.3459 4.92268 15.0465C4.67873 14.7468 4.72378 14.3053 5.02327 14.0611L11.4656 8.81309L5.0428 3.95372C4.73481 3.72046 4.67405 3.28145 4.90705 2.97325C5.14025 2.66504 5.57924 2.60448 5.88752 2.83751L12.9168 8.15587C13.3313 8.46953 13.3423 9.08825 12.9393 9.41661L5.90705 15.1471Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.89891 20.1701C7.5137 20.484 6.94635 20.4262 6.63231 20.0412C6.31849 19.656 6.37623 19.0896 6.76122 18.7756L11.0727 15.2629L15.3843 11.7502L6.78661 5.24529C6.39056 4.94534 6.31208 4.38081 6.6118 3.98454C6.91159 3.58832 7.47619 3.51025 7.87255 3.80974L17.2456 10.9015C17.7806 11.3068 17.7952 12.1064 17.2749 12.5304L7.89891 20.1701Z"
        fill="currentColor"
      />
    </svg>
  ),
});
